/**
 * Shared field error helpers for seller intake form UI.
 */
import { sellerIntakeMobileFocusHandler } from "../../../utils/sellerIntake/sellerIntakeFormMobile";
import { useLocale } from "../../../intl";
import { translateValidationMessage } from "../../../intl/validationMessages.js";

export { sellerIntakeMobileFocusHandler as sellerIntakeFieldFocusHandler };

/**
 * @param {{ fieldKey: string, message?: string|null }} props
 */
export function SellerFieldError({ fieldKey, message }) {
  const { t } = useLocale();
  if (!message) return null;
  return (
    <p id={`seller-intake-error-${fieldKey}`} className="sell-car-form__field-error" role="alert">
      {translateValidationMessage(t, message)}
    </p>
  );
}

/**
 * @param {string} fieldKey
 * @param {Record<string, string|null|undefined>} [errors]
 */
export function sellerFieldDescribedBy(fieldKey, errors = {}) {
  return errors[fieldKey] ? `seller-intake-error-${fieldKey}` : undefined;
}

/**
 * @param {string} fieldKey
 * @param {Record<string, string|null|undefined>} [errors]
 */
export function sellerFieldInvalid(fieldKey, errors = {}) {
  return Boolean(errors[fieldKey]);
}
